var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5H15L13.6 17.9224H3.4L2 5.5Z",
    fill: "#B7364D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5L8.2 3.83621L15 4.5V5H2V4.5Z",
    fill: "#B7364D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H9.5V4.5H7V2Z",
    fill: "#B7364D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashbox);
export default __webpack_public_path__ + "static/media/icon-trashbox.abd0229c4ebb699f13a735a7a5cebc0e.svg";
export { ForwardRef as ReactComponent };